import React from 'react';
import ReactPopover from 'react-popover';
import style from './popover.scss';

const Popover = ({ preferPlace = 'below', ...props }) => (
  <ReactPopover preferPlace={preferPlace} {...props} appendTarget={document.body}/>
);

export default Popover;


// WEBPACK FOOTER //
// ./src/components/common/popover.js